<div class="flex-parent">
  <app-logout *ngIf="logoutEmitter | async" (logoutCompleted)="refresh()"></app-logout>
  <div class="login-form-div">
    <app-logo></app-logo>
    <form class="login-form" [formGroup]="loginForm">
      <bos-reactive-mat-form-input [initFocus]="true" [translateKeyPrefix]="'loginForm.'" [fieldName]="'username'"
                                   [parentFormGroup]="loginForm"
                                   [inputType]="'login'"></bos-reactive-mat-form-input>
      <bos-reactive-mat-form-input [translateKeyPrefix]="'loginForm.'" [fieldName]="'password'"
                                   [parentFormGroup]="loginForm"
                                   [inputType]="'password'"></bos-reactive-mat-form-input>


      <div class="additional-options">
        <mat-checkbox class="w100 position-left" [formControlName]="'rememberMe'" color="accent"> {{'loginForm.rememberMe' | translate}}</mat-checkbox>
        <a routerLink="/boslogin/remind" class="link-wide text-details text-details-accent" matTooltip="{{'password.forgot.tooltip' | translate}}">{{'password.forgot' | translate}}</a>
      </div>

      <app-domain-select [group]="loginForm" [controlName]="'domain'" [labelKey]="'domain.select'"></app-domain-select>

      <button class="left-margin login-button" mat-flat-button color="primary" [disabled]="!loginForm.valid"
              (click)="login()" type="submit" prevent-double-submit [@inProgress]="inProgress">
        <mat-icon color="accent" class="login-icon">done</mat-icon>
        <app-progress-button
                [progress]="inProgress"
                [success]="success"
                [standardButtonLabel]="'loginForm.loginButton'"
                [successButtonLabel]="'loginForm.loginButton.success'"></app-progress-button>
      </button>
    </form>

    <p *ngIf="loginProperties.length > 0">
      {{'login.or' | translate}}
    </p>

    <button class="additional-login-button" mat-flat-button
            (click)="loginWith(provider)"
            prevent-double-submit
            *ngFor="let provider of loginProperties">
      <mat-icon class="bigger-icon" svgIcon="{{provider.style | lowercase}}" *ngIf="!provider?.customIcon"></mat-icon>
      <img src="{{provider?.customIcon}}" class="bigger-icon" *ngIf="provider?.customIcon"/>
      {{provider?.customName ? provider.customName : ('login.with' | translate : [provider.name])}}
    </button>

    <div class="footer-div">
      <app-footer></app-footer>
    </div>
    <div class="creator-div">
      <app-link></app-link>
    </div>

    <div class="version-div">
      <app-version-info></app-version-info>
    </div>
  </div>
</div>



